import PropTypes from 'prop-types'
import { UseTheme } from '../../hooks/useTheme'
import { UseTypeFontSize } from '../../hooks/useTypeFontSize'
import { getStyle } from '../helper'

export const Icon = ({ iconRef, className, style, ...others }) => {
  const typeFontSize = UseTypeFontSize()
  const theme = UseTheme()

  return (
    <i
      ref={iconRef}
      className={['cursorPointer', className].join(' ')}
      style={getStyle(style, theme, typeFontSize)}
      {...others}
    />
  )
}

Icon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
}

Icon.defaultProps = {
  style: {},
}
